import React from 'react'

import { isFunction } from 'lodash'

import FilesUpload from '../Files/FilesUpload'
import { onError } from '../../../utils/apiHelper'
import { useSelector } from 'react-redux'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'

const MAX_FILE_SIZE_MB = 2

const FilesUploader = ({ onUpload, ...props }) => {
  const t = useSelector(selectTranslate)

  const handleUpload = (file) => {
    if (isFunction(onUpload)) {
      if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
        onError(t('files_uploader.file_too_large', { size: MAX_FILE_SIZE_MB }))
      } else {
        onUpload(file)
      }
    }

    return false
  }

  return (
    <FilesUpload {...props} onUpload={handleUpload} />
  )
}

export default FilesUploader
